export const YDS_GRADES = [
  '5.0',
  '5.1',
  '5.2',
  '5.3',
  '5.4',
  '5.5',
  '5.6',
  '5.7',
  '5.8',
  '5.9',
  '5.10a',
  '5.10b',
  '5.10c',
  '5.10d',
  '5.11a',
  '5.11b',
  '5.11c',
  '5.11d',
  '5.12a',
  '5.12b',
  '5.12c',
  '5.12d',
  '5.13a',
  '5.13b',
  '5.13c',
  '5.13d',
  '5.14a',
  '5.14b',
  '5.14c',
  '5.14d',
  '5.15a',
  '5.15b',
  '5.15c',
  '5.15d',
] as const

export const V_GRADES = [
  'V0',
  'V1',
  'V2',
  'V3',
  'V4',
  'V5',
  'V6',
  'V7',
  'V8',
  'V9',
  'V10',
  'V11',
  'V12',
  'V13',
  'V14',
  'V15',
  'V16',
  'V17',
] as const

export const YDS_MAX = YDS_GRADES.length - 1
export const V_MAX = V_GRADES.length - 1
export const V_OFFSET = 100

export const CLIMB_TYPES = [
  { bit: 1, label: 'Sport', key: 'sport' },
  { bit: 2, label: 'Trad', key: 'trad' },
  { bit: 4, label: 'Boulder', key: 'bouldering' },
  { bit: 8, label: 'Alpine', key: 'alpine' },
  { bit: 16, label: 'Ice', key: 'ice' },
  { bit: 32, label: 'Mixed', key: 'mixed' },
  { bit: 64, label: 'Aid', key: 'aid' },
  { bit: 128, label: 'TR', key: 'tr' },
] as const

export const ROPE_TYPE_MASK = 1 | 2 | 8 | 16 | 32 | 64 | 128
export const BOULDER_TYPE_MASK = 4

export function parseGradeNumeric(grade: string): number {
  if (!grade) return -1
  const g = grade.trim()

  const vMatch = g.match(/^V(\d+)/)
  if (vMatch) {
    const n = parseInt(vMatch[1], 10)
    return n <= 17 ? V_OFFSET + n : -1
  }

  const ydsMatch = g.match(/^5\.(\d+)([+-]?)([a-d]?)/)
  if (!ydsMatch) return -1

  const num = parseInt(ydsMatch[1], 10)
  if (num <= 9) return Math.min(num, 9)
  if (num > 15) return -1

  const base = (num - 10) * 4 + 10
  const letter = ydsMatch[3]
  const suffix = ydsMatch[2]

  if (letter) return base + (letter.charCodeAt(0) - 97)
  if (suffix === '+') return base + 3
  return base
}

export function ydsLabel(index: number): string {
  return index >= 0 && index < YDS_GRADES.length ? YDS_GRADES[index] : ''
}

export function vLabel(index: number): string {
  return index >= 0 && index < V_GRADES.length ? V_GRADES[index] : ''
}
